import { FitnessProfile } from "@/clients/models/FitnessProfile";
import { FitnessProfileService } from "@/clients/services/FitnessProfileService";
import { QueryKeys } from "@/constants/query-keys";
import { useQuery } from "@tanstack/react-query";

export const useGetFitnessProfile = () => {
  const {
    data: fitnessProfile,
    isLoading,
    isError,
    error,
  } = useQuery<FitnessProfile>({
    queryKey: [QueryKeys.FITNESS_PROFILE],
    queryFn: async () => {
      const { data } = await FitnessProfileService.getFitnessProfileApiV1FitnessProfileGet();

      return data;
    },
  });

  return { fitnessProfile, isLoading, isError, error };
};
